// extracted by mini-css-extract-plugin
export default {"content":"WalletProfile_content__zgOW2","tabsWrapper":"WalletProfile_tabsWrapper__yQ1hr"};